import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Apollo } from 'apollo-angular';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { config } from '@app/app.config';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  constructor(private router: Router,
    private apollo: Apollo,
    private http: HttpClient) {}

  setAccessToken(token) {
    localStorage.setItem('access_token', token);
  }

  getAccessToken() {
    return localStorage.getItem('access_token');
  }

  logout() {
    localStorage.removeItem('access_token');
    this.apollo
      .getClient()
      .resetStore()
      .then(() => {
        window.location.href = '/auth/login';
        // this.router.navigateByUrl('/auth/login').then();
      });
  }

  getAuthCode(): Observable<{ authCode: string }> {
    return this.http.get<{authCode: string}>(
      config.httpURL + `/api/auth/token/get-auth-code`,
      { headers: { Authorization: `Bearer ${this.getAccessToken()}` }}
    );
  }
}
